import { TRootState } from "Redux/Reducers";

export const getLastEventParentCategoryId = (state: TRootState) => state.eventParentCategory.lastUpdateId;
